<template>
    <div>
        <el-form :inline="true" :model="searchForm"  class="forTbFilter">          
            <el-form-item label="白名单类型"> 
                <el-select v-model="searchForm.groupType" clearable>
                    <el-option value="1" label="成员语音白名单"></el-option>
                    <el-option value="2" label="群组语音白名单"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="接入号：">
                <el-input v-model.trim="searchForm.intoNo" clearable></el-input>
            </el-form-item>

            <el-form-item label="群组语音ID：">
                <el-input v-model.trim="searchForm.groupId"  placeholder="非必填项" clearable></el-input>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary"  @click="getAdminCardListHandler">搜索查询</el-button>
               <el-button type="primary" class="onlyBtn" @click="showManyCardImport">新增白名单</el-button>
            </el-form-item>
        </el-form>
        <el-table  
        :data="tbpg.tableData"
        :default-sort = "{prop: 'status'}"
         border max-height="610" >
           <el-table-column type="index" label="序号" width="50" ></el-table-column>
            <el-table-column prop="whiteNumber" label="接入号码" ></el-table-column>
            <el-table-column prop="name" label="状态" ></el-table-column>
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>     
        <el-dialog :title="title" :visible.sync="importCardVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="searchForm1" :model="searchForm1"  label-width="100px">
                  <el-form-item label="白名单类型"> 
                <el-select v-model="searchForm1.groupType" clearable>
                    <el-option value="1" label="成员语音白名单"></el-option>
                    <el-option value="2" label="群组语音白名单"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item  v-if="searchForm1.groupType==1" label="接入号：">
                <el-input v-model.trim="searchForm1.intoNo"  clearable></el-input>
            </el-form-item>
            <el-form-item label="白名单号码:">
                <el-input v-model.trim="searchForm1.voiceIntoNo" clearable></el-input>
            </el-form-item>
            <el-form-item label="所属群组ID：">
                <el-input v-model.trim="searchForm1.groupId" placeholder="非必填项" clearable></el-input>
            </el-form-item>      
       
            <el-form-item label="卡类型：" prop="type">
                    <el-radio-group v-model="searchForm1.type">
                        <el-radio label="1">新增</el-radio>
                        <el-radio label="4">删除</el-radio>
                        <el-radio label="3">重新增加</el-radio>
                    </el-radio-group>
            </el-form-item>
                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="getAdminCardListHandler1">确 定</el-button>
            </div> 
        </el-dialog> 
    </div>
</template>

<script>
import {getAdminCardList2,getAdminCardList3, exportSimInfo, deleteCard} from '@/api/sim.js'
import {sendSMS} from '@/api/sms.js'
import common from '@/utils/common.js'
export default {
    data(){         
        return {
            searchForm: {
                state:'',
                dataLevel: '',
                totalFlow: '',
                sn: null,
                simPoolId: '',
                id:'',
                groupId:'',
                groupType:'',
                type:null
            },
            searchForm1: {
                state:'',
                dataLevel: '',
                totalFlow: '',
                sn: null,
                simPoolId: '',
                id:'',
                groupId:'',
                groupType:'',
                type:null,
                voiceIntoNo:null
            },
            
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },  
            flowPoolOption: [],
            supplierOption: [],//运营商名称列表
            cardStateOption: [],
           
            actionFormDataRules:{
                msg:[{required: true, message: '请输入短信内容', trigger: 'blur'}]
            },
            sendSMSVisible: false,//发送短信编辑框
            confirmDialogVisible: false,//删除卡片确认框
            confirmToSendSMSVisible: false,  //短信发送确认框
            actionFormData:{//短信发送等动作携带的数据对象
                receiveIntoNo: '',
                msg:'',
            },
            cardId:'',
            title:'',
            importCardVisible:false
                
        }
    },
    methods: {
        
        getAdminCardListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);            
            getAdminCardList2(data).then(res => {    
                console.log(res);
                common.listCallback(this, res, 'tbpg');
            
                
            })
        },
        getAdminCardListHandler1($event){
            var data = common.getRequestParams(this, 'tbpg', this.searchForm1);            
            getAdminCardList3(data).then(res => {
                 if(res.data.code == 200){  
                   this.$message({message: res.data.message, type: 'success'});    
                    this.importCardVisible = false;          
                }else{           
                 this.$message.error(res.data.message);
                 this.importCardVisible = false; 
                    
                }
            })
        },
         cancel(){            
            this.importCardVisible = false; 
            
        },
        getOptionsOfSelect(){       
            common.getSupplierOptsCom(this, 'supplierOption');    
            
        },
         showManyCardImport(){
            
            this.title = "新增白名单";
            this.importCardVisible = true;
        },
         
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('detailMenu').click();
        },
        exportAdminSimInfoHandle(){//导出excel文件
            var data = JSON.parse(JSON.stringify(this.searchForm));
            data.token = localStorage.getItem('token');
            data.pageSize = 10000;
            data.prePageNum = 10000;
            this.exportExcel('/excels/admin/sim/all', data);
            this.$message.success('下载中……');
        },
        updateDowntime(){//一键更新停机
            common.sysRequest('sim/updateStop', {}, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message({message: res.data.message, type: 'success'});
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAdminCardListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAdminCardListHandler();
        },
        showConfirmToRemoveDialog(row){
            this.cardId = row.id;
            this.confirmDialogVisible = true;
        },
        showSendSMSDialog(row){
            this.actionFormData.receiveIntoNo = row.intoNo;
            this.sendSMSVisible = true;
        },
        hideSendSMSDialog(){
            this.sendSMSVisible = false;    
            this.$refs.actionFormData.resetFields();  
        },
        showConfirmToSendSMSDialog(){
            this.$refs.actionFormData.validate(valid => {
                if(valid){
                    this.confirmToSendSMSVisible = true;
                }
            });
        },
        sendSMSAction(){
            let data = {
                receiveIntoNo: this.actionFormData.receiveIntoNo.split("；"),
                msg: this.actionFormData.msg,
            }
            sendSMS(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.getAdminCardListHandler();
                }else{
                    this.$message.error(res.data.message);
                }
                this.actionFormData.receiveIntoNo = '';
                this.actionFormData.msg = '';
                this.sendSMSVisible = false;
                this.confirmToSendSMSVisible = false;
            })
        },
        handleDeleteCard(){
            let param = {id:this.cardId};
            deleteCard(param).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }

                this.confirmDialogVisible = false;
                this.cardId = '';
                this.getAdminCardListHandler();

            });
        },
        formatActivationrTime(row) {
            return row.activationrTime==null ? '' : row.activationrTime.split(' ')[0];
        },    

        formatExpireTime(row) {
            return row.expireTime==null ? '' : row.expireTime.split(' ')[0];
        }, 


    },
    created () {
        this.searchForm.state = this.$store.state.menu.cardState;
        this.searchForm.dataLevel = this.$store.state.menu.cardDataLevel;
    },

    computed: {
        searchDatefromDataSummary() {
            return {
                cardState:this.$store.state.menu.cardState,
                dataLevel:this.$store.state.menu.cardDataLevel
            }

        },

        
    },

    watch:{
        
    }
}
</script>

<style lang="scss" scoped>
    .span-defined{
        width: 284px;
        display: inline-block;
        position: relative;
        margin-left: 30px;
    }
    .label-defined{
        display: inline-block;
        height: 32px;
        line-height:32px;
        font-size: 14px;
        color: #606266;
    }
    .percent-label{
        height: 28px;
        line-height: 28px;
        background: #fff;
        z-index: 100;
        position: absolute;
        right: 120px;
        top: 2px;
        font-size: 16px;
    }

    
</style>

